import React from "react";
import styles from './Styles.module.scss';
import Layout from "@/components/layout/Layout";
import classNames from 'classnames';
import BlockContent from "@sanity/block-content-to-react";
import BreadcrumbSchema from "@/components/schema/BreadcrumbSchema";

export default function Terms({body}) {

  const serializers = {
    types: {},
    marks: {link: ({mark, children}) => <a href={mark.href} target={'_blank'}>{children}</a>}
  }

  const renderBlockContent = (node) => {
    if (!node) {
      return undefined;
    }
    if (Array.isArray(node)) {
      return node.map(renderBlockContent);
    }
    const serializer = serializers.types[node._type];
    return serializer
        ? serializer({node})
        : <BlockContent key={node._key}
                        blocks={node}
                        serializers={serializers}/>;
  }

  return (
      <Layout>
        <BreadcrumbSchema crumbs={[{name: "Terms & Conditions", path: "terms"}]}/>
        <div className={styles.container}>
          <div className={styles.heading}>
            <h1>Terms & Conditions</h1>
          </div>
          <div className={classNames(styles.content)}>
            <div className={classNames(styles.inner)}>
              {renderBlockContent(body)}
            </div>
          </div>
        </div>
      </Layout>
  )
}
